import { render, staticRenderFns } from "./NotifyTeacher.vue?vue&type=template&id=7ead014e&scoped=true"
import script from "./NotifyTeacher.vue?vue&type=script&lang=js"
export * from "./NotifyTeacher.vue?vue&type=script&lang=js"
import style0 from "./NotifyTeacher.vue?vue&type=style&index=0&id=7ead014e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ead014e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ead014e')) {
      api.createRecord('7ead014e', component.options)
    } else {
      api.reload('7ead014e', component.options)
    }
    module.hot.accept("./NotifyTeacher.vue?vue&type=template&id=7ead014e&scoped=true", function () {
      api.rerender('7ead014e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifyTeacher/NotifyTeacher.vue"
export default component.exports